import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CardList from "../core-elements/CardList";
import CardDocument from "../core-elements/CardDocument";
import ItemSearches from "./list-item/ItemSearches";
import ItemDocument from "./list-item/ItemDocument";
import ItemEntries from "./list-item/ItemEntries";
import ItemDiscussions from "./list-item/ItemDiscussions";
import ItemContentRevision from "./list-item/ItemContentRevision";
import ItemKnowledgeItem from "./list-item/ItemKnowledgeItem";
import ItemRequiredReading from "./list-item/ItemRequiredReading";
import ItemRework from "./list-item/ItemRework";
import ItemAny from "./list-item/ItemAny";
import ItemList from "./list-item/ItemList";
import ItemNotification from "./list-item/ItemNotification";
import ItemExpertQuestion from "./list-item/ItemExpertQuestion";
import MenuLink from "./menu/MenuLink";
import MenuLinkDialog from "./menu/MenuLinkDialog";
import CardStats from "../core-elements/CardStats";
import { removeNullCharacters } from "pdfjs-dist/build/pdf";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import { Trans, withTranslation } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import { Alert, AlertTitle } from "@material-ui/lab";
import PropertyNames from "../PropertyNames";

const styles = (theme) => ({
  wrapper: {
    height: "100%",
    width: "100%",
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
});

const elementMappings = {
  CardDocument,
  CardList,
  ItemSearches,
  ItemRequiredReading,
  ItemDiscussions,
  ItemEntries,
  ItemDocument,
  ItemKnowledgeItem,
  ItemAny,
  ItemList,
  ItemNotification,
  MenuLink,
  CardStats,
  MenuLinkDialog,
  ItemRework,
  ItemContentRevision,
  ItemExpertQuestion,
};

const portletsNotAvailableToMobile = [
  "com.kpsol.api.apicommon.stats.MyStatsInterface",
  "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface",
];
/**
 * Dynamically creates and wraps a portlet
 */
export class ElementWrapper extends Component {
  static propTypes = {
    fullscreen: PropTypes.bool,
    portlet: PropTypes.object.isRequired,
  };
  render() {
    let WrappedElement = this.props.portlet.elementType;
    let listItem = null;
    let listItemName = null;
    let listItemTitleColumn = null;
    let settingType = null;
    let { classes, ...withoutClasses } = this.props;
    if (this.props.portlet.elementType === "CardList") {
      if (
        this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.history.SearchHistoryInterface" ||
        this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface"
      ) {
        listItemTitleColumn = {
          name: "searchString",
          message: "settings_searchhistory_searchText",
        };
        listItemName = "ItemSearches";
        listItem = elementMappings["ItemSearches"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.content.KnowledgeItemInterface"
      ) {
        listItemName = "ItemKnowledgeItem";
        listItem = elementMappings["ItemKnowledgeItem"];
        listItemTitleColumn = {
          name: "documentTitle",
          message: "global_document_title",
        };
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.rework.ReworkInterface"
      ) {
        listItemName = "ItemRework";
        listItem = elementMappings["ItemRework"];
        listItemTitleColumn = {
          name: "targetTitle",
          message: "global_rework",
        };
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.document.DocumentInterface" ||
        this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.document.ReportInterface"
      ) {
        listItemName = "DocumentItem";
        listItem = elementMappings["ItemDocument"];
        listItemTitleColumn = {
          name: "userTitle",
          message: "global_document_title",
        };
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.discussions.EntryInterface"
      ) {
        listItemTitleColumn = {
          name: "title",
          message: "global_title",
        };
        listItemName = "ItemEntries";
        listItem = elementMappings["ItemEntries"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface"
      ) {
        listItemTitleColumn = {
          name: "title",
          message: "global_title",
        };
        listItemName = "ItemDiscussions";
        listItem = elementMappings["ItemDiscussions"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface"
      ) {
        listItemTitleColumn = {
          name: "title",
          message: "global_title",
        };
        listItemName = "ItemRequiredReading";
        listItem = elementMappings["ItemRequiredReading"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.list.UserListInterface"
      ) {
        listItemName = "ItemAny";
        listItem = elementMappings["ItemAny"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.list.ListUserListsInterface"
      ) {
        listItemName = "ItemList";
        listItem = elementMappings["ItemList"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.hottopic.HotTopicInterface"
      ) {
        listItemName = "ItemNotification";
        listItem = elementMappings["ItemNotification"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.rework.ReworkInterface"
      ) {
        listItemName = "ItemRework";
        listItem = elementMappings["ItemRework"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.content.DocumentContentRevisionInterface"
      ) {
        listItemName = "ItemContentRevision";
        listItem = elementMappings["ItemContentRevision"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface"
      ) {
        listItemTitleColumn = {
          name: "title",
          message: "global_title",
        };
        listItemName = "ItemExpertQuestion";
        listItem = elementMappings["ItemExpertQuestion"];
        settingType = elementMappings[null];
      } else if (
        this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface"
      ) {
        listItemName = "DocumentItem";
        listItem = elementMappings["ItemDocument"];
        listItemTitleColumn = {
          name: "userTitle",
          message: "global_document_title",
        };
        settingType = elementMappings[null];
        WrappedElement = elementMappings[this.props.portlet.elementType];
      }
      WrappedElement = elementMappings["CardList"];
    } else if (this.props.portlet.elementType === "CardStats") {
      WrappedElement = elementMappings[this.props.portlet.elementType];
    } else if (this.props.portlet.elementType === "MenuLink") {
      WrappedElement = elementMappings[this.props.portlet.elementType];
    } else if (this.props.portlet.elementType === "MenuLinkDialog") {
      WrappedElement = elementMappings[this.props.portlet.elementType];
    } else if (this.props.portlet.elementType === "CardDocument") {
      WrappedElement = elementMappings[this.props.portlet.elementType];
    }

    if (typeof WrappedElement === "undefined") {
      return null;
    }

    return (
      <div style={{ height: "100%" }} id="hammondo1">
        {/* <WrappedElement
          refCallback={this.props.listRef}
          listItem={listItem}
          listItemName={listItemName}
          listItemTitleColumn={listItemTitleColumn}
          settingType={settingType}
          isPortlet={!this.props.portlet.menuPortlet}
          instance={this.props.portlet.instance}
          toggleFilters={this.props.toggleFilters}
          discussionPortlet={true}
          menuDialog={this.props.menuDialog}
          parameters={this.props.parameters}
          updateFilters={this.props.updateFilters}
          setFilterInstance={this.props.setFilterInstance}
          filters={this.props.filters}
          fullscreen={this.props.fullscreen}
          {...withoutClasses}
        /> */}
        <WrappedElement
          firstItemButton={
            (listItemName === "DocumentItem" &&
              (this.props.properties[PropertyNames.DISPLAY_NEW_TAB_ICON] ===
                "true" ||
                this.props.properties[
                  PropertyNames.DISPLAY_NEW_DOCUMENT_PORTLET_ICON
                ] === "true")) ||
            listItemName === "ItemDiscussions" ||
            listItemName === "ItemSearches"
          }
          noTaxonomy={this.props.noTaxonomy}
          refCallback={this.props.listRef}
          listItem={listItem}
          listItemName={listItemName}
          listItemTitleColumn={listItemTitleColumn}
          settingType={settingType}
          isPortlet={!this.props.portlet.menuPortlet}
          instance={this.props.portlet.instance}
          toggleFilters={this.props.toggleFilters}
          discussionPortlet={true}
          menuDialog={this.props.menuDialog}
          parameters={this.props.parameters}
          updateFilters={this.props.updateFilters}
          setFilterInstance={this.props.setFilterInstance}
          filters={this.props.filters}
          fullscreen={this.props.fullscreen}
          isMobile={this.props.isMobile}
          updatePortlet={this.props.updatePortlet}
          {...withoutClasses}
          sidebarTaxonomyFilter={
            this.props.portlet.objectClass ===
            "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface"
              ? true
              : false
          }
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  canEdit: state.layout.edit,
  deletePortletInstance: state.layout.deletePortletInstance,
  currentLayout: state.layout.currentLayout,
  layouts: state.layout.layouts,
  currentUser: state.user.currentUser,
  titles: state.layout.tabs,
  isMobile: state.screen.isMobile,
  properties: state.setting.applicationProperties,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withTranslation()(ElementWrapper)));
